import * as React from 'react';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import { EnumSelect } from '~/components/GenericForm/EnumSelect';
import { Enum } from '~/data/enums';

export type ShowEmployeesModeSelectorProps = {
  options: Enum[];
  setValue: Dispatch<SetStateAction<string>>;
  value: string;
  disabled?: boolean;
};

export const ShowEmployeesModeSelector = (
  props: ShowEmployeesModeSelectorProps,
) => {
  const { options, value, setValue, disabled } = props;

  const { t } = useTranslation();

  return (
    <EnumSelect
      enumOptions={options}
      value={value}
      label={t('laEmployees')}
      onChange={(event) => {
        const value = event.target.value;
        if (!!value && typeof value === 'string') {
          setValue(value);
        }
      }}
      size={'small'}
      sx={{ minWidth: '130px' }}
      disabled={disabled}
    />
  );
};
